import { pythonHost } from '@src/Main/main';

function _onError (source, xhr, status, error) {
  console.error(`[PythonControl] Error from ${source} call`);
  console.error('Status:', status);
  if (error) {
    console.error('Error:', error);
  }
}

export const pythonControl = {
  library: function (pCompletion) {
    return $.ajax({
      url: (pythonHost + '/v1/library'),
      type: 'GET',
      dataType: 'json',
      success: function (_pData) { if (pCompletion) { pCompletion(_pData); } },
      error: function (xhr, status, error) { _onError('library', xhr, status, error); if (pCompletion) { pCompletion(null); } },
    });
  },

  /**
   * @param {(executionState: ExecutionState | null) => void} pCompletion A callback for when the status request has been sent.
   * @return {JQuery.jqXHR}
   */
  status: function (pCompletion) {
    return $.ajax({
      url: (pythonHost + '/v1/application'),
      type: 'GET',
      success: pCompletion,
      error: (xhr, status, error) => {
        _onError('status', xhr, status, error);
        pCompletion(null);
      },
    });
  },

  /**
   * @param {string} pAppName The name of the application to play.
   * @param {(executionState: ExecutionState | null) => void} pCompletion A callback for when the play request has been sent.
   * @return {JQuery.jqXHR}
   */
  play: function (pAppName, pCompletion) {
    return $.ajax({
      url: (pythonHost + '/v1/launcher/' + encodeURI(pAppName) + '/start'),
      type: 'PUT',
      success: pCompletion,
      error: (xhr, status, error) => {
        _onError('play', xhr, status, error);
        pCompletion(null);
      },
    });
  },

  /**
   * @param {string} pAppName The name of the application to stop.
   * @param {(executionState: ExecutionState | null) => void} pCompletion A callback for when the stop request has been sent.
   * @return {JQuery.jqXHR}
   */
  stop: function (pAppName, pCompletion) {
    return $.ajax({
      url: (pythonHost + '/v1/launcher/' + encodeURI(pAppName) + '/stop'),
      type: 'PUT',
      success: pCompletion,
      error: (xhr, status, error) => {
        _onError('stop', xhr, status, error);
        pCompletion(null);
      },
    });
  },

  turnOnAutoLaunch: function (pAppName, pCompletion) {
    return $.ajax({
      url: (pythonHost + '/v1/launcher/' + encodeURI(pAppName) + '/autoLaunch/true'),
      type: 'PUT',
      success: function (_pData) { if (pCompletion) { pCompletion(_pData); } },
      error: function (xhr, status, error) { _onError('turnOnAutoLaunch', xhr, status, error); if (pCompletion) { pCompletion(null); } },
    });
  },

  turnOffAutoLaunch: function (pAppName, pCompletion) {
    return $.ajax({
      url: (pythonHost + '/v1/launcher/' + encodeURI(pAppName) + '/autoLaunch/false'),
      type: 'PUT',
      success: function (_pData) { if (pCompletion) { pCompletion(_pData); } },
      error: function (xhr, status, error) { _onError('turnOffAutoLaunch', xhr, status, error); if (pCompletion) { pCompletion(null); } },
    });
  },

  /** --------------------- U N I M P L E M E N T E D    R O U T E S ---------------------  */

  /**
   * @param {string} pAppName The name of the application to pause.
   * @param {(executionState: ExecutionState | null) => void} pCompletion A callback for when the pause request has been sent.
   * @return {JQuery.jqXHR}
   */
  pause: function (pAppName, pCompletion) {
    return $.ajax({
      url: (pythonHost + '/v1/launcher/' + encodeURI(pAppName) + '/pause'),
      type: 'PUT',
      success: pCompletion,
      error: (xhr, status, error) => {
        _onError('pause', xhr, status, error);
        pCompletion(null);
      },
    });
  },

  /**
   * @param {string} pAppName The name of the application to resume.
   * @param {(executionState: ExecutionState | null) => void} pCompletion A callback for when the resume request has been sent.
   * @return {JQuery.jqXHR}
   */
  resume: function (pAppName, pCompletion) {
    return $.ajax({
      url: (pythonHost + '/v1/launcher/' + encodeURI(pAppName) + '/resume'),
      type: 'PUT',
      success: pCompletion,
      error: (xhr, status, error) => {
        _onError('resume', xhr, status, error);
        pCompletion(null);
      },
    });
  },

  commands: function (pAppName, pBody, pCompletion) {
    return $.ajax({
      url: (pythonHost + '/v1/library/commands/' + encodeURI(pAppName)),
      type: 'POST',
      data: pBody,
      dataType: 'json',
      success: function (_pData) { if (pCompletion) { pCompletion(_pData); } },
      error: function (xhr, status, error) { _onError('commands', xhr, status, error); if (pCompletion) { pCompletion(null); } },
    });
  },
};
